/* ============================================================================
   <rtb-reviews-slot> — a fixed place on the product page for a reviews app.

   Load it with `defer` (classic script, not a module):
       <script src="{{ 'rtb-reviews-slot.js' | asset_url }}" defer></script>

   WHY. A reviews app that ships only an app embed (EZ Amazon Reviews
   Importer, 2026-09-30) injects its widget with a script just before the
   footer section. The footer group also holds Follow us, above the footer,
   so the widget landed between the two and split the social band from the
   footer (client report, 2026-10-01). An app block, where an app has one, goes
   straight into sections/rtb-product-reviews and never reaches this script.

   WHAT IT DOES. Anything inside the layout's <footer> that is not one of the
   footer group's own sections — a node an app inserted — is moved into this
   element: direct children of <footer>, and direct children of a footer
   section that sit before the section's own markup. It watches <footer> for
   late insertions, since apps inject after load. Nothing else on the page is
   touched, and with no app widget it does nothing.
   ---------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (customElements.get('rtb-reviews-slot')) return;

  var SKIP = { SCRIPT: 1, STYLE: 1, LINK: 1, TEMPLATE: 1, NOSCRIPT: 1, META: 1 };

  class RtbReviewsSlot extends HTMLElement {
    connectedCallback() {
      this.footer = document.querySelector('body > footer') || document.querySelector('footer');
      if (!this.footer) return;

      this._collect();
      this._observer = new MutationObserver(this._collect.bind(this));
      this._observer.observe(this.footer, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      this._observer = null;
    }

    /** True for a node an app put into the footer, not the theme. */
    _isForeign(node) {
      if (node.nodeType !== 1 || SKIP[node.tagName]) return false;
      if (node.classList.contains('shopify-section')) return false;
      return true;
    }

    _collect() {
      var moved = [];
      var self = this;

      Array.prototype.forEach.call(this.footer.children, function (child) {
        if (self._isForeign(child)) {
          moved.push(child);
          return;
        }
        // Inside a footer section: an app that targets the section itself
        // prepends its widget before the section's single theme root. Only
        // those leading siblings are taken; the section's own markup, which
        // comes last, never is.
        if (child.classList && child.classList.contains('shopify-section')) {
          var kids = Array.prototype.filter.call(child.children, function (k) {
            return !SKIP[k.tagName];
          });
          for (var i = 0; i < kids.length - 1; i++) {
            if (/review/i.test((kids[i].id || '') + ' ' + (kids[i].className || ''))) moved.push(kids[i]);
          }
        }
      });

      if (!moved.length) return;
      // Our own moves are childList mutations on <footer>; pause to skip them.
      if (this._observer) this._observer.disconnect();
      moved.forEach(function (node) {
        self.appendChild(node);
      });
      this.setAttribute('data-filled', '');
      if (this._observer) this._observer.observe(this.footer, { childList: true, subtree: true });
    }
  }

  customElements.define('rtb-reviews-slot', RtbReviewsSlot);
})();
